import React from 'react';
import { Grid, Icon } from 'semantic-ui-react';
import { SemanticICONS } from 'semantic-ui-react/dist/commonjs/generic';
import styles from './ObjectDetails.module.scss';

type Props = {
  field: string;
  value: string | React.ReactNode;
  icon?: SemanticICONS;
};

function ObjectDetailsField({ field, value, icon }: Props) {
  return (
    <>
      <Grid.Column width={2} className={styles.fieldName}>
        {field}
      </Grid.Column>
      <Grid.Column className={styles.value}>
        {value}
        {icon ? (
          <span className={styles.icon}>
            <Icon name={icon} />
          </span>
        ) : null}
      </Grid.Column>
    </>
  );
}

ObjectDetailsField.defaultProps = {
  icon: undefined,
};

export default ObjectDetailsField;
